$ = require 'jquery'
React = require 'react'
_ = require 'underscore'
{ unsplashClient } = require '@trello/unsplash'
t = require('app/scripts/views/internal/recup-with-helpers')()
l = require 'app/scripts/lib/localize'
{ createBackgroundStyle, createPhotoFromResponse } = require './helpers'
{ PAGE_SIZE } = unsplashClient.constants
PhotoAttributionComponent = require 'app/scripts/views/board-create/photo-attribution-component'


module.exports = class PhotoChooserComponent extends React.Component
  displayName: 'PhotoChooserComponent'

  constructor: (props) ->
    super props
    @state =
      # XXX: duplicated state
      background: null
      hasMore: true
      isLoading: true
      page: 1
      photos: props.seedPhotos
      query: ''
    @debouncedLoadPhotos = _.debounce(@loadPhotos, 250)

  onQueryChanged: (query) ->
    @setState { query: query, photos: [], page: 1, isLoading: true }
    @debouncedLoadPhotos(1, query)

  componentDidMount: ->
    @createObserver()
    @observeMarker()

    # Reload first page of results to reduce chance
    # of stale data resulting in duplicate photos
    @loadPhotos(1)

  componentDidUpdate: ->
    @observeMarker()

  render: t.renderable ->
    { background, hasMore, photos, query, isLoading } = @state
    { selectedBackground } = @props

    setChooserElem = (elem) => @chooserElem = elem
    setLoadingElem = (elem) => @loadingElem = elem

    onBackgroundClick = (bg) =>
      # XXX: duplicated state
      @setState { background: bg }
      @props.onSelect bg

    t.div '.background-chooser', { ref: setChooserElem, tabIndex: 0 }, =>
      t.div '.search-photos', =>
        t.input {
          autoFocus: true
          type: 'text'
          placeholder: l(['background photos', 'photos'])
          value: query
          onChange: (e) =>
            query = e.target.value
            @onQueryChanged(query)
        }
        t.span '.icon-sm.icon-search'
      t.ul '.background-grid', ->
        photos.forEach (bg) ->
          isSelected = bg.value ==
            if background?
              background.value
            else
              selectedBackground.value

          t.li '.background-grid-item', ->
            t.div '.background-grid-trigger.is-photo', {
              className: t.classify { selected: isSelected }
              key: bg.value
              onClick: -> onBackgroundClick bg
              role: 'button'
              style: createBackgroundStyle bg
            }, ->
              if isSelected
                t.icon 'check'

              t.createElement PhotoAttributionComponent,
                user: bg.metadata.user
      if isLoading || hasMore
        t.div '.logo-loading.active', { ref: setLoadingElem }
      else if photos.length == 0
        t.span '.no-results', ->
          t.text l(['background photos', 'no results'])

  createObserver: =>
    if @observer? then return

    cb = (entries) =>
      entry = _.first(entries)
      if entry.isIntersecting || entry.intersectionRatio then @loadNextPage()

    @scrollContainerElem = $(@chooserElem).closest('.pop-over-content').get(0)
    @observer = new IntersectionObserver cb, { root: @scrollContainerElem }

  observeMarker: =>
    if !@observer? || !@loadingElem? then return

    @observer.disconnect()
    @observer.observe @loadingElem

  loadNextPage: =>
    if @state.isLoading then return

    nextPage = @state.page + 1
    @setState { page: nextPage }
    @loadPhotos(nextPage, @state.query)

  loadPhotos: (page, query) =>
    photos =
      if query && query != ''
        unsplashClient.searchPhotos(query, page)
      else
        unsplashClient.getDefaultCollectionPhotos(page)

    photos
      .then (photos) -> photos.map createPhotoFromResponse
      .then (photos) =>
        hasMore = photos.length == PAGE_SIZE
        photos = if page != 1 then @state.photos.concat photos else photos
        @setState { hasMore, isLoading: false, photos }
